import { createVariant } from '../../utils/createVariant';
export const QuoteText = createVariant({
    name: 'quote',
    tagName: 'blockquote',
    baseStyle: ({ theme }) => (Object.assign(Object.assign({}, theme.typography.paragraphs['300Quote']), { margin: 0 })),
});
//# sourceMappingURL=Quote.js.map